import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const handleError = createAction('[ErrorHandling] Handle error', props<{ error: HttpErrorResponse }>());

export const showErrorText = createAction('[ErrorHandling] Show error text', props<{ error: string }>());
